<template>
    <div class="pt-16">
        <div class="text-primary mx-6" v-text="lbl.profile.myCard"></div>

        <div class="splide mt-1" :id="id">
            <div class="splide__track">
                <ul class="splide__list">
                    <template
                        v-for="(card, idx) of creditCardList"
                        :key="`card-${idx}`"
                    >
                        <li class="tab-item splide__slide py-3 first:pl-6">
                            <CreditCard
                                :info="card"
                                @onDeleteCard="showConfirmDelete($event)"
                            ></CreditCard>
                        </li>
                    </template>
                    <li class="tab-item splide__slide py-3 first:pl-6 pr-6">
                        <CreditCard :empty="true"></CreditCard>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="flyout-zone">
        <BottomSheet
            ref="bts"
            v-model="bts"
            :persistent="false"
            @onClose="onBtsClose()"
        >
            <template v-if="btsState == 0">
                <div class="px-6 mt-6 text-center mb-8">
                    <div>
                        <div class="text-lg text-primary uppercase">
                            {{ lbl.profile.confirmDeleteCardTitle }}
                        </div>
                        <div class="mt-4">
                            <VBtn
                                blocked
                                large
                                variant="primary"
                                @click="confirmDelete(targetCard)"
                                >{{ lbl.confirm_redeem.confirm }}</VBtn
                            >
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="px-6 -mt-10 text-center mb-8">
                    <div class="mb-4">
                        <img
                            src="@/assets/icon/dialog/success.svg"
                            class="w-20 h-20 mx-auto"
                            alt
                        />
                    </div>
                    <div>
                        <div
                            class="text-lg text-primary uppercase"
                            v-html="lbl.profile.deleteCardSuccess"
                        ></div>
                    </div>
                </div>
            </template>

            <template #dismiss="{ on }">
                <button type="button" class="outline-none" v-on="on">
                    <img src="@/assets/icon/dialog/close.svg" alt />
                </button>
            </template>
            <Footer :hasPoweredBy="false" />
        </BottomSheet>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin";
import Utility from "@/helper/Utility";
import AccountHelper from "@/helper/AccountHelper";
import CacheHelper from "@/helper/CacheHelper";
import ConfigManager from "@/config/ConfigManager";

// mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin";

// lib
import Splide from "@splidejs/splide";

// component
import CreditCard from "./CreditCard.vue";
import VBtn from "@/components/Button/VBtn.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import BottomSheet from "@/components/Dialog/BottomSheet.vue";

// composable
import useRegisterCardComposable from "@/composables/RegisterCardComposable";
import useCreditCardComposable from "@/composables/CreditCardComposable";
import useDashboardComposable from "@/composables/Dashboard/DashboardComposable";

import { RegisterCardResponseModel } from "@/core/Account/model/RegisterCardModel";
import { CreditCardModelBuilder } from "@/core/JCB/model/CreditCardModel";

export default {
    name: "ProfileCardList",
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    components: {
        CreditCard,
        Footer,
        BottomSheet,
        VBtn,
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    emits: ["onLoading", "onLoaded", "onError", "onShowPopupCampaign"],
    inject: ["modalControllerObj"],
    data: function () {
        return {
            splide: null,
            bts: false,
            btsState: 0,
            targetCard: null,
            dashboardCfg: ConfigManager.getDashboardRegistered(),
        };
    },
    computed: {
        modalController: function () {
            return this.modalControllerObj.value;
        },
    },
    watch: {
        creditCardList() {
            // console.log(val)
            if (this.splide != null) {
                this.splide.destroy();
            }

            this.$nextTick(() => {
                this.setSplide();
            });

            this.$emit("onChageCardList", this.creditCardList);
        },
    },
    mounted: function () {
        this.init();
    },
    beforeUnmount: function () {
        this.splide.destroy();
    },
    setup: function (props, { emit }) {
        const { apiRegisterCreditCard } = useRegisterCardComposable();
        const { creditCardList, apiGetCardList, apiDeleteJCBCard } =
            useCreditCardComposable();

        const { states, apiGetDashboard } = useDashboardComposable(
            ConfigManager.getDashboardRegistered(),
            emit
        );

        return {
            states,
            apiGetDashboard,
            apiRegisterCreditCard,
            creditCardList,
            apiGetCardList,
            apiDeleteJCBCard,
        };
    },
    methods: {
        init: function () {
            this.setSplide();
        },
        setSplide: function () {
            let options = {
                arrows: false,
                loop: false,
                autoWidth: true,
                pagination: false,
                drag: true,
                gap: 16,
            };

            this.splide = new Splide(`#${this.id}.splide`, options)
                .on("click", (slide) => {
                    let card = this.creditCardList[slide.index] || null;
                    this.onClickCard(card);
                })
                .mount();
        },
        onClickCard: function (card) {
            if (card == null) {
                this.tracking.event(
                    "apply_card",
                    "click_apply_card",
                    null,
                    null
                );

                // add card
                let baseUrl = Utility.getWebUrl("webhooks");
                // baseUrl = "https://localhost:5001/webhooks"
                let returnUrl = baseUrl + "/RegisterdCard?target_page=profile";

                const token = AccountHelper.getToken();
                this.apiRegisterCreditCard(token, returnUrl)
                    .then((resp) => {
                        if (resp.success) {
                            let data = new RegisterCardResponseModel(resp.data);
                            let cache = new CacheHelper("session");
                            cache.setCache("registerCard.transId", data.tranId);

                            window.location.replace(data.webPaymentUrl);
                        }
                    })
                    .catch((err) => {
                        this.errorApi(err);
                    });
            }
        },
        onDeleteCard: function () {
            this.tracking.event("delete_card", "click_delete_card", null, null);
        },
        showConfirmDelete: function (targetCard) {
            this.onDeleteCard();

            this.targetCard = targetCard;
            this.$refs.bts.show();
        },
        /**
         * @param {import("@/core/JCB/model/CreditCardModel").CreditCardModel} targetCard
         */
        confirmDelete: function (targetCard) {
            this.$refs.bts.hide();

            this.modalController.loadingModal.show();
            let paramsBuilder = new CreditCardModelBuilder();
            paramsBuilder.setCardNo(targetCard.cardNo);

            this.apiDeleteJCBCard(paramsBuilder)
                .then((success) => {
                    if (success) {
                        this.$nextTick(() => {
                            this.refresh();

                            setTimeout(() => {
                                this.btsState = 1;
                                this.$refs.bts.show();
                            }, 400);
                        });
                    } else {
                        // show error
                        this.modalController.alertModal
                            .setMsg("Can not delete card")
                            .show();
                    }
                })
                .catch((err) => {
                    this.errorApi(err);
                })
                .finally(() => {
                    this.modalController.loadingModal.hide();
                });
        },
        onBtsClose: function () {
            this.$nextTick(() => {
                this.targetCard = null;
            });

            if (this.btsState == 1) {
                this.btsState = 0;
            }
        },
        refresh: function () {
            this.$nextTick(() => {
                this.apiGetCardList();
            });
        },
        refreshAfterVerify: function () {
            this.$nextTick(() => {
                this.apiGetCardList().then((cards) => {
                    // console.log(cards.length);
                    if (cards.length === 1) {
                        this.showThankyouPopup();
                    }
                });
            });
        },
        showThankyouPopup: function () {
            if (this.states.items.length == 0) {
                this.apiGetDashboard(this.dashboardCfg).then(() => {
                    this.displayPopupCampaign();
                });
            } else {
                this.displayPopupCampaign();
            }
        },
        displayPopupCampaign: function () {
            // first campaign
            let dashboard = this.states.items?.[0] ?? null;
            if (dashboard) {
                this.$emit("onShowPopupCampaign", dashboard.id);
            }
        },
    },
};
</script>
